<table mat-table [dataSource]="rows" class="table table-summarize">
    <!-- media -->
    <ng-container matColumnDef="media">
        <th mat-header-cell *matHeaderCellDef>Media</th>
        <td mat-cell *matCellDef="let element">
            <div class="media-status-image">
                <app-channel-status-color-coding *ngIf="showChannelStatusDistinction"
                    [currentChannelStatus]="getChannelStatusForMedia(campaign, element)"></app-channel-status-color-coding>
                <div class="image-style">
                    <ng-container *ngFor="let asset of element.asset">
                        <div class="image-wrapper" *ngIf="asset">
                            <div class="paused-status-tag" *ngIf="asset.status == 'PAUSED' && isEditMode">
                                <h6 class="text-white" style="font-size: xx-small">PAUSED</h6>
                            </div>
                            <img [src]="mediaUrl + '/iintegration/media/' + (asset.thumbnail ? asset.thumbnail : asset.fileName)"
                                alt="media" title="media" class="br-15 img-fluid media-thumb" [ngClass]="{
                                    'translucent-image': asset.status != 'DRAFT' && isEditMode
                                }" />
                        </div>
                    </ng-container>
                </div>
            </div>
        </td>
    </ng-container>

    <!-- rule -->
    <ng-container matColumnDef="rule">
        <th mat-header-cell *matHeaderCellDef>Rule</th>
        <td mat-cell *matCellDef="let element">
            <app-table-data-field [shouldAppearTransclusent]="
                    shouldAppearTransclusent(element.mediaStatus, isEditMode)
                " [visibiltyConditions]="[
                    { ifCond: element.rule != 1, then: element.rule },
                    { ifCond: element.rule == 1, then: 'Generic' }
                ]"></app-table-data-field>
        </td>
    </ng-container>

    <!-- Screens -->
    <ng-container matColumnDef="screens">
        <th mat-header-cell *matHeaderCellDef># Screens</th>
        <td mat-cell *matCellDef="let element">
            <app-table-data-field [subElement]="element.noOfScreens" [shouldAppearTransclusent]="
                    shouldAppearTransclusent(element.mediaStatus, isEditMode)
                "></app-table-data-field>
        </td>
    </ng-container>

    <!-- impressions -->
    <ng-container matColumnDef="impressions">
        <th mat-header-cell *matHeaderCellDef>Impressions</th>
        <td mat-cell *matCellDef="let element">
            <app-table-data-field [subElement]="element.noOfImpressions" [shouldAppearTransclusent]="
                    shouldAppearTransclusent(element.mediaStatus, isEditMode)
                "></app-table-data-field>
        </td>
    </ng-container>

    <!-- plays -->
    <ng-container matColumnDef="plays">
        <th mat-header-cell *matHeaderCellDef># Plays</th>
        <td mat-cell *matCellDef="let element">
            <app-table-data-field [subElement]="element.noOfPlays | number: '1.0-0'" [shouldAppearTransclusent]="
                    shouldAppearTransclusent(element.mediaStatus, isEditMode)
                "></app-table-data-field>
        </td>
    </ng-container>

    <!-- channel -->
    <ng-container matColumnDef="channelName">
        <th mat-header-cell *matHeaderCellDef>Channel</th>
        <td mat-cell *matCellDef="let element">
            <app-table-data-field [subElement]="element.channelName" [shouldAppearTransclusent]="
                    shouldAppearTransclusent(element.mediaStatus, isEditMode)
                "></app-table-data-field>
        </td>
    </ng-container>

    <!-- location -->
    <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef>Location</th>
        <td mat-cell *matCellDef="let element">
            <app-table-data-field [subElement]="element.location" [shouldAppearTransclusent]="
                    shouldAppearTransclusent(element.mediaStatus, isEditMode)
                "></app-table-data-field>
        </td>
    </ng-container>

    <!-- Start Date -->
    <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef>Start Date</th>
        <td mat-cell *matCellDef="let element">
            <app-table-data-field [subElement]="element.startDate" [shouldAppearTransclusent]="
                    shouldAppearTransclusent(element.mediaStatus, isEditMode)
                "></app-table-data-field>
        </td>
    </ng-container>

    <!-- End Date -->
    <ng-container matColumnDef="endDate">
        <th mat-header-cell *matHeaderCellDef>End Date</th>
        <td mat-cell *matCellDef="let element">
            <app-table-data-field [subElement]="element.endDate" [shouldAppearTransclusent]="
                    shouldAppearTransclusent(element.mediaStatus, isEditMode)
                "></app-table-data-field>
        </td>
    </ng-container>

    <!-- price -->
    <ng-container matColumnDef="cost">
        <th mat-header-cell *matHeaderCellDef>Price</th>
        <td mat-cell *matCellDef="let element">
            <app-table-data-field [visibiltyConditions]="[
                    {
                        ifCond: element.cost != null,
                        then: element.cost.value | currency: element.cost.currencyCode
                    },
                    {
                        ifCond: element.cost == null,
                        then: 0
                    }
                ]" [shouldAppearTransclusent]="
                    shouldAppearTransclusent(element.mediaStatus, isEditMode)
                "></app-table-data-field>
        </td>
    </ng-container>

    <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="9999" style="text-align: center">
            No data matching the filter
        </td>
    </tr>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
</table>